import Vue from 'vue'
import App from '@/app.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify';
import Amplify, * as AmplifyModules from 'aws-amplify'
// @ts-ignore
import { AmplifyPlugin } from 'aws-amplify-vue'
import { Constants } from './api-constants'

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.config.productionTip = false;

Amplify.configure({
  Auth: {

    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.VUE_APP_FEDERATED_IDENTITY,

    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: process.env.VUE_APP_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,
  },
  API: {
    endpoints: [
      {
        name: Constants.API_NAME,
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_AWS_REGION
      }
    ]
  }
});

/**
 * 
 *  Need to test the following code before integrating with our app
 * 
 */

 /*
let handleOutsideClick: any;
Vue.directive('closable', {
  bind (el: any, binding: any, vnode: any) {
    handleOutsideClick = (e:any) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach( (refName: any) => {
        if (!clickedOnExcludedEl) {
          const excludedEl: any = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})
*/

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
